import type { ProductGenre } from '@/app/lib/api/types-api'
import { resolveProductGenre } from '@/app/lib/utils'

import { FAQ_CATEGORY_ALIASES } from './constants'
import type { FaqCategory } from './types'

/** Las 7 claves reales de `FaqCategory` — una por CSV de `docs/seo/faq/`. */
const FAQ_CATEGORIES: readonly FaqCategory[] = [
  'conciertos',
  'teatro',
  'festivales',
  'deporte',
  'cultura',
  'en-familia',
  'experiencias',
]

function isFaqCategory(value: string): value is FaqCategory {
  return (FAQ_CATEGORIES as readonly string[]).includes(value)
}

/** Normaliza y resuelve alias — misma cadena tanto si viene de la URL como de `genres`. */
function toFaqCategory(value: string | null | undefined): FaqCategory | null {
  if (!value) return null

  const normalized = value.trim().toLowerCase()
  if (isFaqCategory(normalized)) return normalized

  return FAQ_CATEGORY_ALIASES[normalized] ?? null
}

/**
 * Decide el catálogo de FAQs de la ficha: slug de categoría de la propia URL
 * primero, `genres` de la respuesta de la PDP como respaldo — mismo criterio
 * que `resolveRatingSystem` (`src/app/lib/ratings/resolveRatingSystem.ts`).
 * `null` cuando ninguna fuente resuelve a una categoría reconocida (directa o
 * por alias) ⇒ el bloque de FAQs no se muestra.
 */
export function resolveFaqCategory(
  categoriaSlug: string,
  genres?: ProductGenre[] | null,
): FaqCategory | null {
  const fromUrl = toFaqCategory(categoriaSlug)
  if (fromUrl) return fromUrl

  const genreNicename = resolveProductGenre(genres)?.nicename
  return toFaqCategory(genreNicename)
}
